import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const DBKBankApi = createApi({
  reducerPath: "DBKBankApi",
  baseQuery,
  tagTypes: ["DBKBank"],
  endpoints: (builder) => ({
    getDBKBank: builder.query({
        query: ({customerid}) => `/customer/CustomDetailsDrawback/${customerid}`,
      transformResponse: (response) => {
        return response?.data;
      },
      providesTags: ["DBKBank"],
    }),
  }),
});

export const { useGetDBKBankQuery } = DBKBankApi;

